import React, { useState, useEffect } from "react";
import {
  Modal,
  Select,
  FormLayout,
  TextContainer,
  TextStyle,
} from "@shopify/polaris";

export default function ChangeFulfillmentLocationModal({
  open,
  order,
  locations,
  currentLocationId,
  onSave,
  onClose,
  saving,
}) {
  const [selectedLocation, setSelectedLocation] = useState(
    currentLocationId ? currentLocationId.toString() : ""
  );

  useEffect(() => {
    if (currentLocationId) {
      setSelectedLocation(currentLocationId.toString());
    }
  }, [currentLocationId, open]);

  const handleSave = () => {
    if (selectedLocation) {
      onSave(selectedLocation);
    }
  };

  const locationOptions = locations.map((location) => ({
    label: location.name || location.address1,
    value: location.id.toString(),
  }));

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Change Fulfillment Location"
      primaryAction={{
        content: "Change Location",
        onAction: handleSave,
        loading: saving,
        disabled: !selectedLocation || saving,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: onClose,
          disabled: saving,
        },
      ]}
    >
      <Modal.Section>
        <FormLayout>
          <TextContainer>
            <TextStyle variation="subdued">
              Order: {order?.name}
            </TextStyle>
            <TextStyle variation="subdued">
              Change which location this order is assigned to for fulfillment.
            </TextStyle>
          </TextContainer>
          <Select
            label="New Location"
            options={locationOptions}
            value={selectedLocation}
            onChange={setSelectedLocation}
            disabled={saving}
          />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );
}

